import cn from 'classnames'
import s from './Checkbox.module.scss'

interface Props {
  checked: boolean
  onChange: () => void
  className?: string
  label?: string
  disabled?: boolean
}

const defaultProps = {
  className: undefined,
  label: undefined,
  disabled: false,
}

const Checkbox = ({
  checked,
  onChange,
  className,
  label,
  disabled,
}: Props): JSX.Element => {
  const handleChange = () => {
    if (disabled) return
    onChange()
  }

  return (
    <div
      data-testid="checkbox"
      className={cn(s.checkbox, className, { [s.disabled]: disabled })}
      onClick={handleChange}
      onKeyPress={handleChange}
      aria-label="toggleCheck"
      role="button"
      tabIndex={0}
    >
      <input
        data-testid="checkbox-input"
        type="checkbox"
        name="favori-checkbox"
        readOnly
        checked={checked}
        disabled={disabled}
      />
      <span className={s.checkmark} />
      {label && <span className={s.label}>{label}</span>}
    </div>
  )
}

Checkbox.defaultProps = defaultProps
export default Checkbox
